<template>
  <!-- 已审核 -->
  <div class="pendingApproval">
    <el-form class="searchForm" :inline="true" label-position="right" label-width="110px">
      <el-form-item label="学校" prop="schoolName">
        <el-input v-model="searchForm.schoolName" name="schoolName" placeholder="请输入学校名称" class="handle-form-input" />
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="searchForm.title" name="title" placeholder="请输入标题" class="handle-form-input" />
      </el-form-item>
      <el-form-item label="短信内容" prop="template">
        <el-input v-model="searchForm.template" name="template" placeholder="请输入短信内容" class="handle-form-input" />
      </el-form-item>
      <el-form-item label="审核状态" prop="companyAuditStatus">
        <el-select v-model="searchForm.companyAuditStatus" size="medium" class="edit-form-input">
          <el-option label="全部" value="" />
          <el-option label="审核通过" value="2" />
          <el-option label="审核不通过" value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="第三方审核状态" prop="thirdPartyAuditStatus">
        <el-select v-model="searchForm.thirdPartyAuditStatus" size="medium" class="edit-form-input">
          <el-option label="全部" value="" />
          <el-option label="审核中" value="1" />
          <el-option label="审核通过" value="2" />
          <el-option label="审核不通过" value="3" />
        </el-select>
      </el-form-item>
      <el-form-item style="margin-left:15px;">
        <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
          查询
        </el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="listLoading" :data="viewData" highlight-current-row fit element-loading-text="Loading" class="list-table">
      <el-table-column type="index" width="55" align="center" label="序号" />
      <el-table-column label="学校" prop="schoolName" align="center" />
      <el-table-column label="标题" prop="title" align="center" />
      <el-table-column label="短信内容" align="left" width="300">
        <template slot-scope="scope">
          <el-tooltip effect="light" placement="top-start">
            <div slot="content">
              {{ scope.row.template }}
            </div>
            <div class="ellipsis">
              {{ scope.row.template }}
            </div>
          </el-tooltip>
          <!-- <div>2、{{scope.row.contentTwo}}</div> -->
        </template>
      </el-table-column>
      <el-table-column label="审核状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.companyAuditStatus!=3">
            {{ scope.row.companyAuditStatus ==1 ?'审核中':scope.row.companyAuditStatus ==2?'审核通过':'审核不通过' }}
          </span>
          <el-link v-else type="primary" :underline="false" @click="handleOperationButton('companyFailCause',scope.row)">
            审核不通过
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="第三方审核状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.thirdPartyAuditStatus!=3">
            {{ scope.row.thirdPartyAuditStatus ==1 ?'审核中':scope.row.thirdPartyAuditStatus ==2?'审核通过':'审核不通过' }}
          </span>
          <el-link v-else type="primary" :underline="false" @click="handleOperationButton('thirdPartyFailCause',scope.row)">
            审核不通过
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="300">
        <!-- slot-scope="scope" -->
        <template slot-scope="scope">
          <el-button type="primary" size="medium" :disabled="scope.row.thirdPartyAuditStatus==3?false:true" @click="handleOperationButton('pass',scope.row)">
            重新申请
          </el-button>
          <el-button type="primary" size="medium" :disabled="scope.row.thirdPartyAuditStatus==3?false:true" @click="handleOperationButton('noPass',scope.row)">
            审核不通过
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total="page.total" :page.sync="page.pageNum" :limit.sync="page.pageSize" @pagination="pageCurriculumList" @handleSizeChange="handleSizeChange" />
    <el-dialog :close-on-click-modal="false" :visible.sync="reasonVisible" title="驳回理由" width="400px">
      <el-form label-position="right" label-width="100px">
        <el-form-item label="驳回理由">
          <el-input v-model="reasonRejection" disabled rows="5" type="textarea" class="handle-form-input" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="reasonVisible=false">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <!-- 审核不通过原因 -->
    <reviewFailedDialog
      v-if="failedVisible"
      :visible.sync="failedVisible"
      :template-id="detailData.id"
      @refreshList="getTableList"
    />
    <!-- 重新申请 -->
    <approvedDialog
      v-if="approveVisible"
      :visible.sync="approveVisible"
      :type="'reapply'"
      :template-id="detailData.id"
    />
  </div>
</template>
<script>
import { getAuditedPageList } from '@/api/messageCenter/index.js';
import reviewFailedDialog from './reviewFailedDialog.vue';
import approvedDialog from './approvedDialog.vue';
export default {
  components: { reviewFailedDialog, approvedDialog },
  data() {
    return {
      reasonVisible: false,
      approveVisible: false,
      failedVisible: false,
      searchForm: {
        schoolName: '',
        title: '',
        template: '',
        companyAuditStatus: '', // 公司审核状态
        thirdPartyAuditStatus: ''// 第三方审核状态
      },
      page: { // 分页参数
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      listLoading: false, // 表格刷新loading
      viewData: [],
      option: {},
      detailData: {},
      reasonRejection: ''
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    handleOperationButton(type, row) {
      this.detailData = row;
      if (type === 'pass') {
        // 打开重新通过审核弹框
        this.approveVisible = true;
      } else if (type === 'noPass') {
        // 打开不通过弹框
        this.dialogAuditeVisible = false;
        this.failedVisible = true;
      } else if (type === 'companyFailCause') {
        this.reasonRejection = row.companyFailCause;
        this.reasonVisible = true;
      } else {
        this.reasonRejection = row.thirdPartyFailCause;
        this.reasonVisible = true;
      }
    },
    handleSearchFilter() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.option = {
        schoolName: this.searchForm.schoolName,
        title: this.searchForm.title,
        template: this.searchForm.template,
        companyAuditStatus: this.searchForm.companyAuditStatus,
        thirdPartyAuditStatus: this.searchForm.thirdPartyAuditStatus
      };
      this.getTableList();
    },
    pageCurriculumList(obj) {
      this.page.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.page.pageNum = 1;
      this.page.pageSize = obj.limit;
      this.getTableList();
    },
    // 获取列表
    getTableList() {
      this.listLoading = true;
      getAuditedPageList({ ...this.option, pageNum: this.page.pageNum, pageSize: this.page.pageSize }).then(res => {
        this.listLoading = false;
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.viewData = [];
          this.page.total = 0;
        } else {
          this.viewData = res.data.list;
          this.page.total = res.data.total;
        }
      }).catch(err => {
        // this.$message({ type: 'warning', message: '暂无数据' });
        this.listLoading = false;
        console.log(err);
      });
    }
  }
};
</script>
<style lang="scss">
  .el-tooltip__popper{
      max-width: 500px !important;
    }
</style>
<style lang="scss" scoped>
.pendingApproval{
    .edit-form-input{
        width: 150px;
    }
    .ellipsis {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

}
</style>

